import React from "react";
import { Typography, Box, Container } from "@mui/material";

interface PageTitleProps {
  title: string;
  subtitle?: string;
  cta?: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  textAlign?: "left" | "center" | "right";
  py?: number | { xs: number; md: number };
  titleColor?: string;
  subtitleColor?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  title,
  subtitle,
  cta,
  maxWidth = "lg",
  textAlign = "center",
  py = { xs: 6, md: 8 },
  titleColor = "white",
  subtitleColor = "white",
}) => {
  const justifyContent =
    textAlign === "right"
      ? "flex-end"
      : textAlign === "left"
        ? "flex-start"
        : "center";
  return (
    <Box
      sx={{
        py,
      }}
    >
      <Container maxWidth={maxWidth}>
        <Typography
          variant="h2"
          component="h1"
          sx={{
            mb: subtitle ? 3 : 0,
            textAlign,
            fontWeight: 700,

            color: titleColor,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              textAlign,
              opacity: 0.9,
              lineHeight: 1.5,
              maxWidth: "800px",
              mx: textAlign === "center" ? "auto" : "unset",
              color: subtitleColor,
            }}
          >
            {subtitle}
          </Typography>
        )}
        {cta && (
          <Box
            sx={{
              display: "flex",
              justifyContent,
              mt: subtitle ? 0 : 2,
            }}
          >
            {cta}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default PageTitle;
